import { atom } from 'jotai'
import type { ActionInlineDraft } from './inline-drafts'

export const actionInlineDraftsAtom = atom<Record<string, ActionInlineDraft>>({})

export interface TitleCommit {
  promise: Promise<boolean>
  needsAnotherPass: boolean
}

/**
 * Shared by the independently mounted title field and floating controls.
 * Keeping the queue beside the draft atom makes both identities stable across
 * action-view Fast Refresh.
 */
export const titleCommitsInFlight = new Map<string, TitleCommit>()

const updateTails = new Map<string, Promise<void>>()

/**
 * Serialize title and body PATCHes for one action while allowing unrelated
 * actions to update independently.
 */
export function enqueueInlineDraftUpdate<T>(actionId: string, update: () => Promise<T>): Promise<T> {
  const previous = updateTails.get(actionId) ?? Promise.resolve()
  const result = previous.then(update)
  const tail = result.then(
    () => undefined,
    () => undefined,
  )
  updateTails.set(actionId, tail)
  void tail.then(() => {
    if (updateTails.get(actionId) === tail) {
      updateTails.delete(actionId)
    }
  })
  return result
}
